<template>
  <v-card-text style="font-size:16px;">
    <h3>Set transfer extra store price</h3>
    <v-divider />
    <v-card-text>
      <v-layout row class="text-xs-center" v-for="item in 3" :key="item">
        <v-flex xs3 md2 style="padding-top:15px;">{{item}} ร้าน :</v-flex>
        <v-flex xs3 md2 class="text-xs-left" style="padding-top:15px;">คิดค่าบริการ</v-flex>
        <v-flex xs3 sm2>
          <v-text-field
            v-if="item==1"
            solo
            v-model="extra_store.tes_price_first"
            hide-details
            placeholder="Price"
            :disabled="isEditTransfer"
          ></v-text-field>
          <v-text-field
            v-if="item==2"
            solo
            v-model="extra_store.tes_price_second"
            hide-details
            placeholder="Price"
            prepend-inner-icon="add"
            :disabled="isEditTransfer"
            class="ww"
          ></v-text-field>
          <v-text-field
            v-if="item==3"
            :disabled="isEditTransfer"
            solo
            v-model="extra_store.tes_price_third"
            hide-details
            placeholder="Price"
            prepend-inner-icon="add"
          ></v-text-field>
        </v-flex>
        <v-flex xs3 md2 style="padding-top:15px;">บาท</v-flex>
      </v-layout>
    </v-card-text>
    <v-divider />
    <v-card-actions class="pb-0">
      <v-spacer />
      <v-btn
        color="primary"
        v-if="!isEditTransfer"
        class="black--text"
        @click="updateExtraStore()"
      >save</v-btn>
      <v-spacer />
      <span transition="fade" style="position:absolute;right:50px;">
        <v-icon color="green" v-if="update_loading == 2">check</v-icon>
        <v-icon color="red" v-if="update_loading == 3">close</v-icon>
        <v-progress-circular
          :width="3"
          :size="15"
          indeterminate
          color="grey"
          v-if="update_loading == 1"
        ></v-progress-circular>
        {{ update_loading == 1 ? 'Updating' : update_loading == 2 ? 'Update successfully' : update_loading == 3 ? 'Cant update' : null}}
      </span>
    </v-card-actions>
  </v-card-text>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  data() {
    return {
      item: "",
      update_loading: 0
    };
  },
  methods: {
    fetchData() {
      this.$store.dispatch("fetchFoodExtraBack/getExtraStore");
    },
    async updateExtraStore() {
      this.update_loading = 1;
      this.update_loading = await this.$store.dispatch(
        "fetchFoodExtraBack/updateExtraStore",
        this.extra_store
      );
    }
  },
  computed: {
    ...mapState({
      extra_store: state => state.fetchFoodExtraBack.extra_store
    }),
    ...mapGetters(["isEditTransfer"])
  },
  created() {
    this.fetchData();
  }
};
</script>
